import React from 'react';
import SeasonStatsLeaderboard from '../components/SeasonStatsLeaderboard';
import './Pages.css';

function SeasonStats() {
  return (
    <div className="page">
      <SeasonStatsLeaderboard />
    </div>
  );
}

export default SeasonStats;
